import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Category } from "../../types/types";
import useMediaQuery from "../../hooks/useMediaQuery";
import { mobileWidth } from "../../utils/constants";
import { useAppSelector } from "../../services/hooks";
import { useGetUserEntitlementsQuery, useGetUserQuery } from "../../services/api/user.api";
import Loader from "../loader/loader";
import { useRoutes } from "../../hooks/useRoutes";
import { adminSelector } from "../../services/selectors/user.selectors";
import useInactivityTimer from "../../hooks/useInactivityTimer";
import { isAuthSelector, showUnauthorizedModalSelector } from "../../services/selectors/auth.selectors";
import { quotaDataSelector, restrictionTypeSelector } from "../../services/selectors/accessControl.selectors";
import { trialSelector } from "../../services/selectors/entitlements.selectors";
import TrialBanner from "../TrialBanner/TrialBanner";
import SeatPackPastDueBanner from "../seatPackPastDueBanner/SeatPackPastDueBanner";
import Modal from "../modals/modal/Modal";
import InactivityWarning from "../modals/inactivityWarning/inactivityWarning";
import InactivityLogoutPopup from "../modals/inactivityLogoutPopup/inactivityLogoutPopup";
import {
  companiesForSuperUserSelector,
  impersonationCompanyNameSelector,
} from "../../services/selectors/utils.selectors";
import CompanyImpersonationNotice from "../companyImpersonationNotice/companyImpersonationNotice";
import { useActions } from "../../services/hooks/useActions";
import { useGetCompaniesMutation, useGetCompanyByIdQuery } from "../../services/api/utils.api";
import i18n from "../../i18n";
import {
  //addKeysToAllTranslatedElements,
  enableTranslationMode,
} from "../../translationMode";
import { isSuperAdmin } from "../../services/selectors/admin.selectors";
import { useSelector } from "react-redux";
//import { setSuperAdmin } from "../../services/slices/admin.slice";
import ChangeEditingModeButton from "../changeEditingModeButton/changeEditingModeButton";
import EditModeNotice from "../EditModeNotice/EditModeNotice";
import PrivacyPolicyConsentPopup from "../modals/privacyPolicyConsentPopup/privacyPolicyConsentPopup";
import { LanguageSelection } from "../LanguageSelection/LanguageSelection";
import ErrorPopup from "../modals/errorPopup/errorPopup";
import { tWithKeyAttr as t } from "../../i18nHelper";
import { peekPostAuthRedirect } from "../../utils/postLoginRedirect";
import { formatDateInIsrael } from "../../utils/utils";

window.enableTranslationMode = enableTranslationMode;

function App() {
  const navigate = useNavigate();
  const hasOpenedModalRef = useRef(false);
  const [openModal, setOpenModal] = useState(false);
  // useEffect(() => {
  //   if(admin || dataL)
  //   {
  //   if (i18n.isInitialized) {
  //     addKeysToAllTranslatedElements();
  //   } else {
  //     i18n.on("initialized", () => {
  //       addKeysToAllTranslatedElements();
  //     });
  //   }
  //   }
  // }, []);
  const [close, setClose] = useState(false);
  const isSuperAd = useSelector(isSuperAdmin);
  const [dataFromL, setDataFromL] = useState(false);
  const [translationMode, setTranslationMode] = useState<boolean>(dataFromL);
  // useEffect(() => {
  //   setTranslationMode(dataFromL);
  // }, [dataFromL]);
  // const dispatch = useDispatch();
  //
  // useEffect(() => {
  //   const admin = sessionStorage.getItem("isAdmin") === "true";
  //   if (admin || dataL) {
  //     dispatch(setSuperAdmin({ flag: true }));
  //     setTranslationMode(true);
  //   } else if (isSuperAd && !close) {
  //     setTranslationMode(true);
  //   }
  // }, []);
  const handleToggle = () => {
    if (translationMode) {
      setClose(true);
      setTranslationMode(false);
    } else {
      setClose(false);
      sessionStorage.setItem("isAdmin", "true");
      setTranslationMode(true);
    }
  };

  useEffect(() => {
    if (!hasOpenedModalRef.current) {
      setOpenModal(true);
      hasOpenedModalRef.current = true;
    } else (window as any).enableTranslationMode?.(translationMode);
  }, [translationMode]);

  const [dataL, setDataL] = useState(false);
  useEffect(() => {
    setDataL(dataL);
  }, [dataL]);
  const mobile = useMediaQuery(mobileWidth);

  const admin = useAppSelector(adminSelector);
  const isAuth = useAppSelector(isAuthSelector);
  const companies = useAppSelector(companiesForSuperUserSelector);
  const impersonationCompanyName = useAppSelector(
    impersonationCompanyNameSelector
  );
  const showUnauthorizedModal = useAppSelector(showUnauthorizedModalSelector);
  const restrictionType = useAppSelector(restrictionTypeSelector);
  const quotaData = useAppSelector(quotaDataSelector);
  const trial = useAppSelector(trialSelector);
  const {
    setImpersonationCompanyName,
    clearUnauthorizedModal,
    hideRestrictionPopup,
    setEntitlements,
    clearEntitlements,
  } = useActions();

  const { isLoading: isUserLoading } = useGetUserQuery();
  const { data, refetch, fulfilledTimeStamp } = useGetUserEntitlementsQuery(undefined, { skip: !admin.id });
  const lastFetchTsRef = useRef<number | undefined>(undefined);
  useEffect(() => {
    if (fulfilledTimeStamp !== undefined) {
      lastFetchTsRef.current = fulfilledTimeStamp;
    }
  }, [fulfilledTimeStamp]);

  useEffect(() => {
    const FIVE_MIN = 5 * 60 * 1000;
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && admin.id) {
        const stale = !lastFetchTsRef.current || Date.now() - lastFetchTsRef.current > FIVE_MIN;
        if (stale) refetch();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [refetch, admin.id]);

  // trial?.active in deps: when the backend flips active to false, cleanup must clear
  // the pending timer — do not remove that dep even though the guard also checks active.
  useEffect(() => {
    if (!trial?.active || !trial?.endsAt) return;
    const ms = new Date(trial.endsAt).getTime() - Date.now();
    if (ms <= 0) return;
    const id = setTimeout(() => refetch(), ms);
    return () => clearTimeout(id);
  }, [trial?.active, trial?.endsAt, refetch]);

  useEffect(() => {
    if (data) {
      setEntitlements(data);
    }
  }, [data, setEntitlements]);

  useEffect(() => {
    // Clear stale entitlements when the identity changes
    clearEntitlements();
  }, [admin?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!isAuth) clearEntitlements();
  }, [isAuth, clearEntitlements]);
  // Fetch company details to populate company name and logo
  useGetCompanyByIdQuery(admin.companyId, {
    skip: !admin.companyId || admin.companyId === 0,
  });

  // useGetAllCompaniesQuery(undefined, {
  //   skip: admin.roleId !== -1,
  // });
  //get companies for super admin

  const [getCompanies] = useGetCompaniesMutation();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [activeCategory, setActiveCategory] = useState(Category.Main);
  const changeCategory = (e: React.MouseEvent, cat: Category) => {
    if (!mobile) {
      e?.stopPropagation();
    }
    setActiveCategory(cat);
  };
  const [showWarning, setShowWarning] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  useInactivityTimer(setShowWarning, setShowLogoutModal);
  const [position, setPosition] = useState({ top: 16, left: 16 });

  useEffect(() => {
    if (Array.isArray(companies)) {
      // make sure companies is a type of array
      const companyName = companies.find((c) => c.id === admin.companyId)?.name;
      if (companyName) {
        setImpersonationCompanyName(companyName);
      }
    }
  }, [admin.companyId, companies, setImpersonationCompanyName]);

  useEffect(() => {
    if (admin.roleId === -1) {
      getCompanies();
    }
  }, [admin.roleId, getCompanies]);

  //כיוון לפי שפה
  useEffect(() => {
    const lang = i18n.language || "he";
    //const baseLang = lang.split("-")[0]; // למשל "en-US" → "en"

    // const dir = ["he", "ar", "fa", "ur"].includes(baseLang) ? "rtl" : "ltr";

    document.documentElement.setAttribute("lang", lang);
    // document.documentElement.setAttribute('dir', dir);
  }, []);

  // GMT
  const [showGMTPopup, setShowGMTPopup] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("privacyConsent");
    if (!consent) {
      setShowGMTPopup(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("privacyConsent", "true");
    setShowGMTPopup(false);
  };

  const routes = useRoutes(changeCategory, admin.fakeCompanyId, dataL);
  const pendingPostAuthRedirect = peekPostAuthRedirect();

  const handleDragEnd = (top: number, left: number) => {
    setPosition({ top, left });
  };
  return (
    <>
      <LanguageSelection />
      {isAuth && trial?.active && (
        <TrialBanner endsAt={trial.endsAt ?? null} />
      )}
      {/* Guards itself: the query is skipped unless an admin is signed in, and the banner renders
          null until a pack is actually past due. */}
      <SeatPackPastDueBanner />
      {showGMTPopup && (
        <Modal onClose={() => { }}>
          <PrivacyPolicyConsentPopup handleAccept={handleAccept} />
        </Modal>
      )}

      {isSuperAd && (
        <ChangeEditingModeButton
          translationMode={translationMode}
          onToggle={handleToggle}
        />
      )}
      {translationMode && <EditModeNotice />}

      {isUserLoading && !pendingPostAuthRedirect ? <Loader /> : routes}
      {isAuth && showWarning && (
        <Modal onClose={() => setShowWarning(false)}>
          <InactivityWarning onClose={() => setShowWarning(false)} />
        </Modal>
      )}
      {isAuth && showUnauthorizedModal && (
        <Modal onClose={clearUnauthorizedModal}>
          <ErrorPopup onClose={clearUnauthorizedModal} text={t('UNAUTHORIZED_ERROR')} />
        </Modal>
      )}
      {isAuth && (restrictionType === "feature" || restrictionType === "resource") && (
        <Modal onClose={hideRestrictionPopup}>
          <ErrorPopup
            onClose={hideRestrictionPopup}
            text={t(restrictionType === "feature" ? "FEATURE_NOT_IN_PLAN_ERROR" : "RESOURCE_QUOTA_EXCEEDED_ERROR")}
          />
        </Modal>
      )}
      {isAuth && restrictionType === "feature_quota" && quotaData && (
        <Modal onClose={hideRestrictionPopup}>
          <ErrorPopup
            onClose={hideRestrictionPopup}
            text={
              quotaData.resetsAt
                ? `${t("FEATURE_QUOTA_EXCEEDED_ERROR")} ${t("FEATURE_QUOTA_RESETS_AT", {
                    date: formatDateInIsrael(quotaData.resetsAt),
                  })}`
                : t("FEATURE_QUOTA_EXCEEDED_ERROR")
            }
            actionText={t("BUY_CREDITS")}
            onAction={() => {
              hideRestrictionPopup();
              navigate("/myAccount?tab=buy-credits");
            }}
          />
        </Modal>
      )}
      {/* {isAuth && restrictionType === "rate_limit" && (
        <Modal onClose={hideRestrictionPopup}>
          <ErrorPopup onClose={hideRestrictionPopup} text={t("TOO_MANY_REQUESTS_ERROR")} />
        </Modal>
      )} */}
      {showLogoutModal && (
        <Modal onClose={() => setShowLogoutModal(false)}>
          <InactivityLogoutPopup onClose={() => setShowLogoutModal(false)} />
        </Modal>
      )}
      {isAuth && admin.roleId === -1 && impersonationCompanyName && (
        <CompanyImpersonationNotice
          name={impersonationCompanyName}
          position={position}
          onDragEnd={handleDragEnd}
        />
      )}
    </>
  );
}

export default App;

declare global {
  interface Window {
    enableTranslationMode: (isEnabled: boolean) => void;
  }
}
